import { LoadingButton } from "@mui/lab"
import { styled } from "@mui/material"

import { BUTTON_RADIUS_MULTIPLIER } from "../../themes/defaultThemeParams"

/**
 * Styled loading button component for use across App. Should be used over
 * generic material UI button component.
 */
const AppLoadingButton = styled(LoadingButton)(({ theme }) => ({
    borderRadius: theme.shape.borderRadius * BUTTON_RADIUS_MULTIPLIER,
    textTransform: "none",
}))

export default AppLoadingButton
